import React from 'react';
import { connect } from 'react-redux';
import { createPureComponent, PathUtils } from 'module/Common';
import { Items } from '../Items';
import { LogoLink, Sizes, Wave, WishHandler, HoverProvider } from 'module/View/Common';
import { Menu } from 'module/Model/Menu';
import { MenuAction, MenuSelector } from 'module/Redux/Menu';
import { ReduxCompatibleDispatch } from 'lib/redux-stabilizer';
import { RouterSelector } from 'module/Redux/Router';
import { State } from 'module/Redux';
import { Wish } from 'module/Model/Wish';

const MenuWishHandler = WishHandler.create<Menu>();

type DispatchProps = {
  closeMenu: () => void;
};

const mapDispatchToProps = (dispatch: ReduxCompatibleDispatch): DispatchProps => ({
  closeMenu: () => dispatch(MenuAction.setClose()),
});

type StateProps = {
  menuWish: Wish<Menu>;
  otherLang: PathUtils.Lang;
};

const mapStateToProps = (s: State): StateProps => ({
  menuWish: MenuSelector.selectMenu(s),
  otherLang: RouterSelector.selectOtherLang(s),
});

type OwnProps = {
  adminBarHeight: number;
  windowWidth: number;
};

type Props = DispatchProps & StateProps & OwnProps;

const MenuContentComp = createPureComponent<Props>(
  'MenuContent',
  ({ menuWish, otherLang, adminBarHeight, closeMenu, windowWidth }) => {
    return (
      <MenuWishHandler
        wish={menuWish}
        handlePending={() => <div>Loading...</div>}
        handleResolved={menu => (
          <>
            <HoverProvider>
              {({ hover, ref }) => (
                <div ref={ref as any}>
                  <LogoLink
                    padding={false}
                    centered={Sizes.isMenuLogoCentered(windowWidth)}
                    size={Sizes.getLogoMenuSize(windowWidth)}
                    onClick={closeMenu}
                  />
                  <Wave
                    centered={Sizes.isMenuLogoCentered(windowWidth)}
                    width={Sizes.getMenuWidthWithoutGutter(windowWidth) + 20}
                    margin={[1, 0.6]}
                    animate={hover}
                  />
                </div>
              )}
            </HoverProvider>
            <Items items={menu} width={Sizes.getMenuWidthWithoutGutter(windowWidth)} />
          </>
        )}
      />
    );
  }
);

export const MenuContent = connect(mapStateToProps, mapDispatchToProps)(MenuContentComp);



// WEBPACK FOOTER //
// ./src/module/View/Menu/Content/MenuContent.tsx